export default "__VITE_ASSET__f5f433c2__"